
































import { defineComponent, computed, PropType } from '@nuxtjs/composition-api';
import { useVSFContext } from '@vue-storefront/core';

interface Product {
  id: string | number;
  [key: string]: any;
}

interface Banner {
  image: {
    urls: {
      url: string;
    }[];
  };
  title?: string;
  urls?: {
    url: string;
  }[];
  link?: {
    url: string;
  };
}

export default defineComponent({
  name: 'ProductGrid',
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true
    },
    banners: {
      type: Array as PropType<Banner[]>
    },
    srpBannerMinHeight: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    const vsfContext = useVSFContext();

    const isCareplanAvailable = computed(() => {
      const wt = vsfContext.$novulo.config.state.getWt();

      return [11, 7, 20, 21, 24, 25].includes(wt);
    });

    const gridItems = computed(() => {
      const items: Array<any> = [];
      const totalProducts = props.products.length;
      const desiredInsertIndex = totalProducts >= 6 ? 5 : 2;
      const insertIndex = Math.min(desiredInsertIndex, totalProducts);
      const algoliaBannerSource = props.banners?.length ? props.banners[0] : null;
      const algoliaBannerId = algoliaBannerSource ? `banner-${Date.now()}` : '';
      const algoliaBannerItem = algoliaBannerSource
        ? {
          ...algoliaBannerSource,
          id: algoliaBannerId,
          type: 'banner',
          uid: algoliaBannerId
        }
        : null;
      const totalTiles = totalProducts + (algoliaBannerItem ? 1 : 0);
      let tileCount = 0;
      let careplanBannerIndex = 0;

      if (totalProducts === 0) {
        if (algoliaBannerItem) items.push(algoliaBannerItem);
        return items;
      }

      props.products.forEach((product, index) => {
        items.push({
          ...product,
          type: 'product',
          uid: `product-${product.id}`,
          productIndex: index
        });

        tileCount += 1;

        if (algoliaBannerItem && index === insertIndex - 1) {
          items.push(algoliaBannerItem);
          tileCount += 1;
        }

        if (tileCount % 6 === 0 && tileCount < totalTiles) {
          if (isCareplanAvailable.value) {
            const isUspBar = careplanBannerIndex % 2 === 0;
            items.push({
              type: 'plp-banner',
              uid: `plp-banner-${tileCount}`,
              mode: isUspBar ? 'usp' : 'insurance'
            });
          }

          careplanBannerIndex += 1;
        }
      });

      return items;
    });

    const handleProductClick = (product, index, event) => {
      emit('product:click', { product, index, event });
    };

    return {
      isCareplanAvailable,
      gridItems,
      handleProductClick
    };
  }
});
